import { Box, Typography } from '@mui/material';
import * as React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Loader, PrimaryButton, SecondaryButton } from 'components';
import '../../style.scss';
import { selectLoader } from 'base/auth/selectors';
import { authSliceActions } from 'base/auth/slice';
import Achievements from './components/achivements';
import Statistics from './components/statistics';
import Sponsors from './components/sponsors';
import GeneralInformation from './components/general-information';
import Badges from './components/badges';

const ProfileView = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoader);
  const navigate = useNavigate();

  React.useEffect(() => {
    dispatch(authSliceActions.fetchUser());
  }, []);

  return (
    <Loader loading={loading ?? false}>
      <div className="row">
        <div className="col d-none d-md-block">
          <Typography variant="h4">
            Profile
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
            Overview of your profile.
          </Typography>
        </div>
        <div className="col d-block d-md-none">
          <Typography variant="h5">
            Profile
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.9 }}>
            Overview of your profile.
          </Typography>
        </div>
        <div className="col-auto d-none d-md-block">
          <PrimaryButton onClick={() => navigate('/profile/update')}>
            Edit profile
          </PrimaryButton>
        </div>
        <div className="col-auto d-block d-md-none">
          <SecondaryButton onClick={() => navigate('/profile/update')}>
            Edit profile
          </SecondaryButton>
        </div>
      </div>

      <Box className="row" sx={{ mt: 4 }}>
        <div className="col-md-7">

          <GeneralInformation />
          <Achievements />
          <Statistics />

        </div>
        <div className="col-md-5">
          <Sponsors />
          <Badges />
        </div>
      </Box>
    </Loader>
  );
};

export default ProfileView;
